import React from 'react';
import { FaTimes, FaExternalLinkAlt } from 'react-icons/fa';
import { Project } from '../data/portfolioData';

interface ProjectModalProps {
  project: Project;
  onClose: () => void;
}

const ProjectModal: React.FC<ProjectModalProps> = ({ project, onClose }) => {
  // Close on overlay click
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Close on Escape key
  React.useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal" role="dialog" aria-modal="true">
        {/* Image */}
        <img
          src={project.image}
          alt={project.name}
          className="modal__image"
        />

        <div className="modal__body">
          {/* Header */}
          <div className="modal__header">
            <div>
              <h2 className="modal__name">{project.name}</h2>
              <p className="modal__tagline">{project.tagline}</p>
            </div>
            <button className="modal__close" onClick={onClose} aria-label="Fermer">
              <FaTimes />
            </button>
          </div>

          {/* Technologies */}
          <div className="modal__techs">
            {project.technologies.map((tech, index) => (
              <span key={index} className="modal__tech">
                {tech}
              </span>
            ))}
          </div>

          {/* Problem / Solution / Approach */}
          <div className="modal__sections">
            <div className="modal__section">
              <div className="modal__section-label">Problème</div>
              <p className="modal__section-text">{project.problem}</p>
            </div>

            <div className="modal__section">
              <div className="modal__section-label">Solution</div>
              <p className="modal__section-text">{project.solution}</p>
            </div>

            <div className="modal__section">
              <div className="modal__section-label">Approche</div>
              <p className="modal__section-text">{project.approach}</p>
            </div>
          </div>

          {/* CTA */}
          {project.liveUrl && project.liveUrl !== '#' && (
            <div className="modal__cta">
              <a
                href={project.liveUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--primary"
              >
                <FaExternalLinkAlt size={14} />
                Voir le projet
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
